// src/utils/constants.ts

/**
 * Глобальные форматы дат для использования во всём приложении
 */
export const DATE_FORMATS = {
  // Стандартные форматы
  DISPLAY: 'dd.MM.yyyy',
  DISPLAY_WITH_TIME: 'dd.MM.yyyy HH:mm',
  ISO: 'yyyy-MM-dd',
  // Форматы для Luxon
  LUXON_DISPLAY: 'dd.MM.yyyy',
  LUXON_DISPLAY_WITH_TIME: 'dd.MM.yyyy HH:mm',
  LUXON_ISO: 'yyyy-MM-dd',
  API_DATE: 'yyyy-MM-dd',
  API_FORMAT: "yyyy-MM-dd'T'HH:mm:ss'Z'",
  // Дополнительные форматы
  TIME_ONLY: 'HH:mm',
  YEAR_MONTH: 'MMMM yyyy',
  SHORT_DATE: 'dd.MM',
  SHORT_MONTH_YEAR: 'MM.yyyy'
} as const;

/**
 * Глобальные настройки локалей
 */
export const LOCALES = {
  DEFAULT: 'ru',
  RU: 'ru-RU',
  EN: 'en-US',
  KZ: 'kk-KZ',
  SUPPORTED: ['ru', 'en'] as const,
} as const;

/**
 * Глобальные настройки пагинации
 */
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50],
  INITIAL_PAGE: 1,
} as const;

/**
 * Настройки форматирования чисел
 */
export const NUMBER_FORMATS = {
  DEFAULT_PRECISION: 2,
  CURRENCY_PRECISION: 0,
  PERCENT_PRECISION: 1
} as const;

/**
 * Общие ключи для сообщений об ошибках (i18n)
 */
export const COMMON_ERROR_MESSAGES = {
  LOADING_ERROR: 'errors.loading_error',
  DETAIL_LOAD_ERROR: 'errors.detail_load_error',
  UPDATE_ERROR: 'errors.update_error',
  SAVE_ERROR: 'errors.save_error',
  DELETE_ERROR: 'errors.delete_error',
  CONNECTION_ERROR: 'errors.connection_error',
} as const;